module.exports = __webpack_public_path__ + "img/1111.9a7206a9.png";